import { notify } from '@/utils/notify';
import axios from 'axios';
import { attachTokenRefresh } from '@/utils/authInterceptors';

const baseURL = process.env.VUE_APP_ENV === 'production'
  ? "https://api.vibrant-america.com/v2/portal/trans-service"
  : "https://api.vibrant-america.com/v2/portal/trans-service-st";

const patientTagsService = axios.create({
  baseURL: baseURL
});

patientTagsService.interceptors.request.use(
  async function (config) {
    let token = sessionStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

patientTagsService.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('Patient Tags API Error:', error);
    if (error.config?.params?.patient_id === null ||
        error.config?.params?.patientId === null ||
        error.config?.url?.includes('/patients/null/tags') ||
        error.config?.url?.includes('/patients/undefined/tags')) {
      console.warn('Silencing tag error for invalid patientId');
      return Promise.reject(error);
    }

    let message = 'An error occurred with patient tags';
    if (error.response) {
      const errorMessage = error.response.data?.errorMessage;
      const statusCode = error.response.status;

      // Silencing 500 internal server error for tags
      if (statusCode === 500) {
        console.warn('Silencing 500 internal server error for tags');
        return Promise.reject(error);
      }

      if (errorMessage === 'TAG_LIMIT_REACHED') {
        message = 'A patient can have maximum 10 tags.';
      } else if (errorMessage === 'TAG_INVALID_NAME') {
        message = 'Invalid tag name.';
      } else if (errorMessage === 'UNAUTHENTICATED') {
        message = 'Please log in to continue.';
      } else if (errorMessage === 'PERMISSION_DENIED') {
        message = 'You do not have permission to perform this action.';
      } else {
        message = errorMessage || `Server Error: ${error.response.status}`;
      }
    } else if (error.request) {
      message = 'Network error - please check your connection';
    }

    notify({
      title: "Error",
      message: message,
      type: "error",
      duration: 5000,
    });

    return Promise.reject(error);
  }
);

attachTokenRefresh(patientTagsService);

export default patientTagsService;
